export function localDateFromUTCDate(date) {
    return [date.getUTCFullYear(), assertMonth(date.getUTCMonth() + 1), date.getUTCDate()];
}
export function normalizeLocalDate(date) {
    return localDateFromUTCDate(new Date(Date.UTC(date[0], date[1] - 1, date[2])));
}
export function normalizeLocalMonth(year, month) {
    const date = new Date(Date.UTC(year, month - 1, 1));
    return [date.getUTCFullYear(), assertMonth(date.getUTCMonth() + 1)];
}
export function assertMonth(month) {
    if (month <= 0 || 12 < month) {
        console.error('month value is wrong:', month);
    }
    return month;
}
export function assertQuarter(quarter) {
    if (quarter <= 0 || 4 < quarter) {
        console.error('quarter value is wrong:', quarter);
    }
    return quarter;
}
